module.exports = __webpack_public_path__ + "static/media/payment.db821e57.png";